import { createContext, useContext } from 'react';

export type InboxBadges = {
  triagem: number;
  minhas: number;
  total: number;
};

export const InboxBadgesContext = createContext<InboxBadges>({
  triagem: 0,
  minhas: 0,
  total: 0,
});

export function useInboxBadges(): InboxBadges {
  return useContext(InboxBadgesContext);
}
